import { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { getCurrentTimezone, localToUTC } from '../../../helpers/dateHelper';
import { useTranslation } from 'react-i18next';

interface TimeZoneInfo {
  fullString: string;
  offset: string;
  name: string;
}

const TimeZoneDisplay = () => {
  const { t } = useTranslation();

  const [timeZoneInfo, setTimeZoneInfo] = useState<TimeZoneInfo | null>(null);
  const [currentTime, setCurrentTime] = useState<Date>(new Date());

  useEffect(() => {
    // Обновляем текущее время каждую секунду
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    // Получаем информацию о часовом поясе
    const timezoneString = getCurrentTimezone();
    const [offset, ...nameParts] = timezoneString.split(' ');
    const name = nameParts.join(' ');

    setTimeZoneInfo({
      fullString: timezoneString,
      offset,
      name
    });

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="mb-6 p-3 bg-content2 rounded-lg">
      <h3 className="text-lg font-medium mb-2">{t("Current Time Zone")}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <div>
          <span className="text-textsecondary">{t("Time Zone")}: </span>
          <span className="font-medium">
            {timeZoneInfo?.name || t("Detecting...")}
          </span>
        </div>
        <div>
          <span className="text-textsecondary">{t("UTC Offset")}: </span>
          <span className="font-medium">
            {timeZoneInfo?.offset || t("Calculating...")}
          </span>
        </div>
        <div>
          <span className="text-textsecondary">{t("Local Time")}: </span>
          <span className="font-medium">
            {format(currentTime, "HH:mm (eeee, dd MMMM yyyy)")}
          </span>
        </div>
        <div>
          <span className="text-textsecondary">{t("UTC Time")}: </span>
          <span className="font-medium">
            {format(localToUTC(currentTime), "HH:mm (eeee, dd MMMM yyyy)")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TimeZoneDisplay;